import { ENTITY_IMAGE_UPLOAD_MAX_BYTES } from "../../../../../src/shared/entityImages";

export const IMAGE_UPLOAD_MAX_BYTES = ENTITY_IMAGE_UPLOAD_MAX_BYTES;

export const IMAGE_TOO_LARGE_MESSAGE = `That image is too large. Please choose one under ${IMAGE_UPLOAD_MAX_BYTES / (1024 * 1024)}MB.`;

export const ALLOWED_IMAGE_MIME_TYPES = ["image/png", "image/jpeg", "image/jpg", "image/webp", "image/gif"] as const;

export const ALLOWED_REFERENCE_IMAGE_MIME_TYPES = ["image/png", "image/jpeg", "image/webp"] as const;

export const MAX_PENDING_UPLOAD_FILES = 10;

export const MAX_PENDING_UPLOAD_FILES_MESSAGE = `You can upload up to ${MAX_PENDING_UPLOAD_FILES} images at a time.`;
